import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SelectWrapper,
    SelectInputContainer,
    SelectInputLabel,
} from 'src/domains/players/webview/components/WithdrawAndDeposit/components/paymentMethodDropdown/PaymentMethodDropdown.style';
import {
    OptionTextContainer,
    SubtitleContainer,
    StyledCheckIcon,
    NewTrashIconWrapper,
    NewTrashIcon,
    Separator,
    SeparatorWrapper,
} from './NewPaymentMethodDropdown.style';
import { ChevronIconWrapper } from 'src/domains/layouts/webview/components/styles/baseDropdownStyle.style';
import { components, OptionProps } from 'react-select';
import { useAppStateContext } from 'src/appState/AppState';
import { DeleteCardPopup } from 'src/domains/players/webview/components/WithdrawAndDeposit/components/DeleteCardPupup/DeleteCardPopup';
import { DeleteCardPopupState } from 'src/domains/players/webview/components/WithdrawAndDeposit/components/DeleteCardPupup/DeleteCardPopup.state';
import { NewPaymentMethodDropdownState, optionType } from './NewPaymentMethodDropdown.state';
import { PaymentMethodDropdownState } from 'src/domains/players/webview/components/WithdrawAndDeposit';

export interface DropDownPropsType {
    allowAddingMethod?: boolean;
    label: string | JSX.Element;
    paymentMethodDropdownState: PaymentMethodDropdownState;
}

const NewPaymentMethodOption = observer(
    'NewPaymentMethodOption',
    ({
        optionProps,
        isActive,
        handleOpenRemoveCardPopup,
    }: {
        optionProps: OptionProps;
        isActive: boolean;
        handleOpenRemoveCardPopup: (id: string, label: string) => void;
    }) => {
        const parsedData = optionType.safeParse(optionProps.data);

        if (parsedData.success === false) {
            console.error('Payment Methods Dropdown - payment method option error');
            return null;
        }

        const { isDisabled, expires, label, value, netDeposit, isSeparator } = parsedData.data;
        if (isSeparator)
            return (
                <SeparatorWrapper>
                    <Separator />
                </SeparatorWrapper>
            );
        else
            return (
                <components.Option {...optionProps}>
                    <OptionTextContainer>
                        <div>{label}</div>
                        <SubtitleContainer>
                            {isDisabled ? `Expired: ${expires ?? ''}` : `Net Deposit Balance: ${netDeposit ?? ''}`}
                        </SubtitleContainer>
                    </OptionTextContainer>
                    {isActive && <StyledCheckIcon />}
                    {isDisabled && !isActive ? (
                        <NewTrashIconWrapper
                            onClick={(): void => {
                                handleOpenRemoveCardPopup(value, label.replaceAll(' ', '').slice(-8));
                            }}
                        >
                            <NewTrashIcon />
                        </NewTrashIconWrapper>
                    ) : null}
                </components.Option>
            );
    }
);

export const NewPaymentMethodDropdown = observer('NewPaymentMethodDropdown', (props: DropDownPropsType) => {
    const { allowAddingMethod = false, label, paymentMethodDropdownState } = props;
    const { common } = useAppStateContext();

    const [deleteCardPopupState] = useState(
        () => new DeleteCardPopupState(common, paymentMethodDropdownState.refreshPaymentMethods)
    );
    const [newMethodState] = useState(
        () => new NewPaymentMethodDropdownState(allowAddingMethod, common, paymentMethodDropdownState)
    );

    return (
        <>
            <SelectInputContainer>
                <SelectInputLabel data-test='select-input-label'>{label}</SelectInputLabel>
                <SelectWrapper
                    newDropdown
                    value={newMethodState.activeElement}
                    options={newMethodState.allOptions}
                    className='custom-dropdown-select'
                    classNamePrefix='react-select'
                    onChange={newMethodState.onChange}
                    components={{
                        Option: (optionProps: OptionProps): JSX.Element => {
                            const option = optionType.safeParse(optionProps.data);
                            const isActive =
                                option.success === true
                                    ? option.data.value === newMethodState.activeElement?.value
                                    : false;

                            return (
                                <NewPaymentMethodOption
                                    optionProps={optionProps}
                                    handleOpenRemoveCardPopup={deleteCardPopupState.handleOpenRemoveCardPopup}
                                    isActive={isActive}
                                />
                            );
                        },
                        DropdownIndicator: (): JSX.Element => <ChevronIconWrapper position='down' />,
                    }}
                    isSearchable={false}
                />
            </SelectInputContainer>
            <DeleteCardPopup deleteCardPopupState={deleteCardPopupState} />
        </>
    );
});
